document.querySelectorAll('[id^="delivery-tag-block-"]').forEach(function(tagBlock) {
  var sectionId = tagBlock.dataset.sectionId;
  var productVariants = document.querySelector('product-variants[data-id="' + sectionId + '"]');
  if (!productVariants) return;

  function updateDeliveryTagVisibility() {
    var variant = productVariants.currentVariant;
    var isTracked = !!(variant && variant.inventory_management);
    tagBlock.style.display = isTracked ? 'none' : '';
  }

  customElements.whenDefined('product-variants').then(function() {
    productVariants.addEventListener('VARIANT_CHANGE', updateDeliveryTagVisibility);
    updateDeliveryTagVisibility();
  });
});